import './App.css';
import About from './Components/About/About';
import Banner from './Components/Banner/Banner';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';
import Navbar from './Components/Navbar/Navbar';
import Projects from './Components/Projects/Projects';
import Skills from './Components/Skills/Skills';
import SocialLinks from './Components/SocialLinks/SocialLinks';

function App() {
  return (
    <div>
      <Navbar />
      <Banner />
      <About />
      <Skills />
      <Projects />
      <SocialLinks />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
